/*
 * @Author: lyx
 * @Date: 2024-12-10 16:47:37
 * @LastEditTime: 2023-06-29 11:02:51
 * @FilePath: /drink_b/src/routes/visualChart/P39/index.js
 * @Description: p39
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title29 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';
import FormChart from './FormChart';
import { index } from 'd3';

class P40 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],

      tableColumns: [],
      tableList: [],
      tableColorList: [],
    }
  }
 
  getMaxIndex = (tableList) => {
    let maxArr = []
    tableList.length && tableList.forEach((ele) => {
      let ii = 0;
      let maxVal = -1
      Object.keys(ele).forEach((key, index) => {
        let val = ele[key];
        if (key !== 'key_0') {
          if (ii === 0) {
            maxVal = parseFloat(val);
          } else {
            maxVal = Math.max(parseFloat(val), maxVal)
          }
          ii += 1;
        }
      });
      maxArr.push(maxVal)
    })
    return maxArr
  }

  getColor = (list, val, index) => {
    // list:整个数组; val:对象中每个key的value值; index:list的index项;
    if (index == 0) {
      return val  == this.getMaxIndex(list)[index]+ '%' ? 'red' : '#000';
    } else {
      return val == this.getMaxIndex(list)[index] ? "red" : "#000"
    }
  }

  fillColor = (tableColumns,list) => {
    const border = `none`
    return tableColumns.map((item, index) => {
      return {
        ...item,
        style: (_, i) => {
          return {
            ...item.style,
            height: 30,
            fontSize: 16,
            textAlign: 'center',
            fontWeight: 'bold',
            color: '#000',
            background: '#fff',
            border: '1px solid #000',
            // borderRight: border,
            // borderBottom: i !== 0 ? '1px solid #000' : border,
          }
        },
        colStyle: (_, ii, i) => {
          return {
            height: 30,
            fontSize: 16,
            textAlign: 'center',
            fontWeight: 'bold',
            color: this.getColor(list, list[ii][item.dataIndex] ,ii),
            background: '#fff',
            border: '1px solid #000',
            // borderRight: border,
            // borderBottom: i !== 0 ? '1px solid #000' : border,
          }
        }
      }
    })
  }

  render() {
    const { chartTitle, chartList, tableColumns, tableList, chartColorList } = this.state;
    return (
      <Stage>
        <Title29 pageNumber="6.27">安踏儿童VS竞品 | KOL整体参与度对比
        </Title29>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.subTitle}>
              安踏儿童KOL用户DB总值排名第一，KOL占比为49.04%，排名第四
            </div>
            <div contentEditable className={s.des}>
              安踏儿童的KOL用户的DB总值为<span className={s.emphasis}>113,710,789<i>DB</i></span>，排名第一。其KOL占比相对较低，为<span className={s.emphasis}>49.04%</span>，在六品牌中排名第四。
            </div>
            <div contentEditable className={s.des}>
            竞品中，耐克儿童更侧重合作KOL来提高传播影响力，其KOL占比最高，为<span className={s.emphasis}>60.29%</span>。
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <TooltipDrawer
                style={{ width: '100%', height: '100%' }}
                formContent={<FormChart onChange={values => this.setState({ ...values })} />}>
                <Chart isShow options={setChart({
                  label: chartTitle,
                  list: chartList,
                  color: chartColorList
                })} />
              </TooltipDrawer>
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable columns={this.fillColor(tableColumns,tableList)} data={tableList} style={{ boxShadow: 'none' }} />
              </TooltipDrawer>
            </div>
          </div>
        </div>
         <div contentEditable className={s.explain}>
          数据说明：本页图表数据观测窗口为2023年1月1日-12月31日。数据来源：新闻媒体类（中央级媒体/泛财经媒体/行业媒体/大众媒体）+资讯网媒+新闻客户端（今日头条/一点资讯等）+自媒体平台（微信号等）+社交平台（微博/知乎等）+短视频类（抖音/快手/视频号/B站等）+消费种草社区（小红书/什么值得买/得物App等）+垂类体育社区（虎扑/懂球帝/Keep等）+其它论坛贴吧等。
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P40);



// WEBPACK FOOTER //
// src/routes/visualChart/P40/index.js